<template>
  <div
    class="d-flex flex-column justify-content-center align-items-center min-vh-100 p-3 text-center"
    style="background-color: #f8f9fa"
  >
    <h1>{{ message }}</h1>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true" />
  </div>
</template>

<script>
  import { contractNLStatus } from '@/services/customer-support/task'

  export default {
    data() {
      return {
        showLoading: true,
        mposId: '',
        message: 'Đang chuyển hướng',
      }
    },
    created() {
      this.mposId = this.$route.params.mposId
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      async fetchData() {
        try {
          this.showLoading = false
          const res = await contractNLStatus(this.mposId)
          if (res.code === 1000) {
            // const { taskId, customerName, email, time, checksum } = res.data;
            // this.$router.replace({
            //   path: '/confirm-contract',
            //   query: {
            //     taskId,
            //     customerName,
            //     email,
            //     time,
            //     checksum,
            //   },
            // })
            window.location.href = res.data
          } else {
            // this.showFailMx(res.message ?? res.error)
            this.message = res.message ?? res.error
          }
        } catch (error) {
          // this.showFailMx(error.response?.data?.message ?? error.message)
          this.message = error.response?.data?.message ?? error.message
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
